export const FORM_CONFIG = {
  webUrl: process.env.REACT_APP_WEB_URL,
};
